import { ComponentProps, ComponentType } from 'react';
import styled from 'styled-components';

import MultiCheckbox from '@r1-frontend/ui-react/components/controls/multiCheckbox';

export const SMultiCheckboxWrapper = styled.div`
    max-width: 360px;
    margin-top: -12px;
`;

export const SMultiCheckbox: ComponentType<ComponentProps<typeof MultiCheckbox>> = styled(MultiCheckbox)`
    margin-top: 12px;

    &:nth-child(4), &:nth-child(5) {
        width: 172px;

        input > span {
            width: inherit;
            text-align: center;
        }
    }
`;
